export const SET_BID = 'SET_BID'
export const UPDATE_STATUS_LOAD_DAY = 'UPDATE_STATUS_LOAD_DAY'
export const SET_LOADING = 'SET_LOADING'
export const FETCH_CURRENT_LOAD_DAY = 'FETCH_CURRENT_LOAD_DAY'
export const SET_SELECTED_RESPONSE = 'SET_SELECTED_RESPONSE'
export const SET_IS_SHOW_DIALOG_SAVE_NOMENCLATURE =
  'SET_IS_SHOW_DIALOG_SAVE_NOMENCLATURE'
